import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { assignUsersToPlacesRequested } from './redux/actions';
import AutoCompleteSingle from '../../common/AutoCompleteSingle';
import LoadingComponent from '../../common/LoadingComponent';
import { getResearchers, assignPlacesLoading } from './redux/selectors';
import UserIcon from '../../icons/userIcon.svg';
import CloseIcon from '../../icons/close-normal.svg';
import { Modal } from 'react-bootstrap';
import './styles.scss';
import { noop } from '../../common/propTypes';

function AssignUsersToPlacesModal({
    places,
    allPlacesSelected,
    isOpen,
    researchers,
    handleClose,
    selectedPlaces,
    assignUsersToPlaces,
    isAssigning,
}) {
    const [selectedResearcher, setResearcher] = useState(null);
    const [researcherList, setResearcherList] = useState([]);

    useEffect(() => {
        if (!isAssigning) {
            setResearcher(null);
            setResearcherList([]);
            handleClose();
        }
    }, [isAssigning]);
    const addResearcher = () => {
        const newRL = [...researcherList];
        if (!newRL.map((s) => s.id).includes(selectedResearcher.id)) {
            newRL.push(selectedResearcher);
            setResearcherList(newRL);
        }
        setResearcher(null);
    };

    const removeResearcher = (id) => {
        setResearcherList(researcherList.filter((s) => s.id !== id));
    };

    const handleAssignPlaces = () => {
        // Iterate over every loaded Place and assign to the researcherList if it's selected
        let projectId;
        const placeIds = [];
        for (let place of places) {
            if (allPlacesSelected || selectedPlaces[place.id]) {
                // Every selected Place is in a single Project, now that we've changed the screen to filter by Project first
                if (place.researchProjectId) {
                    projectId = place.researchProjectId;
                }
                // Only assign Places which are unassigned (to only allow one assignee per Place/Task)
                if (place.isAssigned === false) {
                    placeIds.push(place.id);
                }
            }
        }

        assignUsersToPlaces(projectId, placeIds, researcherList);
    };

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={true} />
        </div>
    );
    return (
        <Modal
            show={isOpen}
            onHide={noop}
            className={'assign-partner-modal'}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            centered={true}
            animation={true}
        >
            <div className="modal-body add-places-modal">
                <div className="row">
                    <div className="col">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                            }}
                        >
                            <div className="row">
                                <h1>
                                    Assign Tasks{' '}
                                    {/* {researcherList.length ? (
                                        <label className="selected-text">{`(${researcherList.length} selected)`}</label>
                                    ) : null} */}
                                </h1>
                            </div>

                            <div className="row add-user">
                                <AutoCompleteSingle
                                    id="researchers-autocomplete"
                                    title="Select Researcher"
                                    isLoading={false}
                                    bootstrapIcon={UserIcon}
                                    disabled={researcherList.length > 0}
                                    options={researchers}
                                    placeholder={'Type Researcher Name'}
                                    getOptionLabel={(option) =>
                                        `${option.fullName}`
                                    }
                                    renderOption={(option) => option.fullName}
                                    value={selectedResearcher}
                                    onSelect={setResearcher}
                                />
                                <button
                                    disabled={
                                        !(
                                            selectedResearcher &&
                                            selectedResearcher.id
                                        )
                                    }
                                    onClick={addResearcher}
                                    className="btn btn-custom btn-sm mt-3"
                                >
                                    Assign
                                </button>
                            </div>

                            {researcherList.length ? (
                                <h3 className="titleStyle2">
                                    {'Assigned Researcher'}
                                </h3>
                            ) : null}
                            <div className="row">
                                {researcherList.map((re) => (
                                    <span key={re.id} className="user-chip">
                                        {re.fullName}
                                        <img
                                            onClick={() =>
                                                removeResearcher(re.id)
                                            }
                                            src={CloseIcon}
                                        />
                                    </span>
                                ))}
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <button
                                        disabled={!researcherList.length}
                                        onClick={handleAssignPlaces}
                                        className="btn btn-custom btn-process mt-4"
                                    >
                                        {isAssigning ? loader : 'Save'}
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        onClick={(e) => {
                                            setResearcher(null);
                                            setResearcherList([]);
                                            handleClose(e);
                                        }}
                                        className="btn btn-custom btn-reset mt-4"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

AssignUsersToPlacesModal.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    researchers: PropTypes.array,
    selectedPlaces: PropTypes.object,
    places: PropTypes.array,
    allPlacesSelected: PropTypes.bool,
    assignUsersToPlaces: PropTypes.func,
    isAssigning: PropTypes.bool,
};

AssignUsersToPlacesModal.defaultProps = {
    isOpen: false,
    handleClose: noop,
    selectedPlaces: [],
    places: [],
    allPlacesSelected: false,
    assignUsersToPlaces: noop,
    isAssigning: false,
};

const mapStateToProps = (state) => {
    return {
        researchers: getResearchers(state),
        isAssigning: assignPlacesLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        assignUsersToPlaces: (researchProjectId, placeIds, researchers) =>
            dispatch(
                assignUsersToPlacesRequested(
                    researchProjectId,
                    placeIds,
                    researchers,
                ),
            ),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AssignUsersToPlacesModal);
